export const siteIdentity = {
  name: 'Casa Borinquen',
  tagline: 'Discover a vibrant social scene where curated events foster lasting friendships and exclusive networking opportunities designed to enrich your lifestyle.',
  siteOrigin: 'https://casa-borinquen.com',
  catalogPath: '/services',
  catalogLabel: 'Services'
} as const;

export const navigation = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/services', label: 'Services' },
  { href: '/gallery', label: 'Gallery' },
  { href: '/blog', label: 'Blog' },
  { href: '/contact', label: 'Contact' }
] as const;

export const inquiryTypes = ['General', 'Booking', 'Membership', 'Event'] as const;

export const contactDetails = {
  email: 'contact@casaborinquen.com',
  phone: '+1-305-555-1234',
  phoneHref: 'tel:+13055551234',
  address: '188 Hood Avenue, Suite 4B'
} as const;
